import React from 'react';
import { Container } from '@material-ui/core';

import {
  BarChart as BarChartContainer,
  CartesianGrid,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  Legend,
  LabelList,
  Bar,
} from 'recharts';
import { chartDataObject, chartDataLegendObject } from '../../@types/chartData';
import { useStyles } from './styles';

import './style.css';

interface legendsProps {
  legendY?: string;
  legendOne?: string;
  legendTwo?: string;
  direction?: boolean;
  percent?: boolean;
  data: chartDataObject[];
}

const BarChart: React.FC<legendsProps> = ({
  legendOne,
  legendTwo,
  direction,
  percent,
  data,
}) => {
  const styles = useStyles();

  return (
    <Container className="Root">
      <ResponsiveContainer width="100%" height={280}>
        <BarChartContainer
          layout={direction ? 'vertical' : 'horizontal'}
          data={data}
          margin={direction ? { top: 10, left: 50 } : {}}
        >
          <Tooltip labelStyle={{ fontWeight: 'bolder' }} cursor={{ fill: '#dcdcdc' }} />
          <CartesianGrid
            stroke="rgba(0, 0, 0, 0.5)"
            strokeDasharray="5 5"
            vertical={!!direction}
            horizontal={!direction}
          />
          <XAxis
            allowDataOverflow
            dataKey={direction ? '' : 'title'}
            stroke="#000000"
            type={direction ? 'number' : 'category'}
            axisLine={!direction}
            tickLine={false}
            tickCount={6}
            tickSize={10}
            tickFormatter={
              direction && percent ? (tick) => `${tick}%` : (tick) => `${tick}`
            }
            domain={direction && !percent ? undefined : [0, 100]}
          />
          <YAxis
            allowDataOverflow
            stroke="#000000"
            dataKey={direction ? 'title' : ''}
            type={direction ? 'category' : 'number'}
            width={direction ? 175 : 50}
            axisLine={!!direction}
            tickLine={false}
            tickCount={6}
            tickSize={10}
            tickFormatter={
              direction ? (tick) => tick : percent ? (tick) => `${tick}%` : (tick) => tick
            }
            domain={direction && !percent ? undefined : [0, 100]}
          />
          <Bar
            dataKey="count_line1"
            className={styles.bar}
            name={legendOne === '' ? ' ' : legendOne}
            label={{ visibility: 'hidden' }}
            fill="#00A7C5"
            barSize={30}
          >
            <LabelList dataKey="count_line1" position={direction ? 'right' : 'top'} formatter={(e)=> percent ? `${e}%` : `${e}`} />
          </Bar>
          {legendTwo ? (
            <Bar
              dataKey="count_line2"
              name={legendTwo}
              className={styles.bar}
              label={{ visibility: 'hidden' }}
              fill="#C59054"
              barSize={30}
            >
              <LabelList dataKey="count_line2" position={direction ? 'right' : 'top'} formatter={(e)=> percent ? `${e}%` : `${e}`} />
            </Bar>
          ) : (
            <></>
          )}

          <Legend verticalAlign="bottom" align="left" iconType="rect" />
        </BarChartContainer>
      </ResponsiveContainer>
    </Container>
  );
};

export default BarChart;
